<template>
  <div class="factory-only-thank-you" :class="[colorTheme]">
    <v-app id="inspire">
      <v-main class="fill-height d-flex align-center justify-center">
        <v-container>
          <v-row justify="center">
            <v-col cols="12" class="text-center">
              <p class="thank-you-message">{{ i18n.factoryOnlyThankYouMessage }}</p>
            </v-col>
          </v-row>
        </v-container>
      </v-main>
    </v-app>
  </div>
</template>

<script>
export default {
  name: 'FactoryOnlyThankYou',
  computed: {
    colorTheme() {
      return this.$store.state.shop.color_theme || '';
    },
    i18n() {
      return this.$store.state[this.$store.state.locale];
    },
  },
};
</script>

<style scoped>
.thank-you-message {
  font-size: 1.25rem;
  line-height: 1.6;
  padding: 1rem;
}
</style>
